import type { ReactNode } from "react";
import { ClipboardList } from "lucide-react";
import { Button } from "@/shared/components/shadcn/Button";
import { InfoRow } from "@/shared/components/ui/InfoRow";
import type { FormSummary } from "../types/formTypes";

interface FormRowProps {
  form: FormSummary;
  onPreview?: () => void;
  onRemove?: () => void;
  onToggle?: () => void;
  selected?: boolean;
  searchText?: string;
  caption?: ReactNode;
}

export function FormRow({ form, onPreview, onRemove, onToggle, selected, searchText, caption }: FormRowProps) {
  return (
    <InfoRow
      title={form.name}
      subtitle={form.version === undefined ? "Current version" : `Version ${form.version}`}
      caption={caption}
      density="compact"
      searchText={searchText}
      selected={selected}
      onClick={onToggle ? undefined : onPreview}
      icon={onToggle ? (
        <label className="flex size-11 cursor-pointer items-center justify-center">
          <input type="checkbox" className="size-5 accent-primary" checked={!!selected}
            aria-label={`Select ${form.name}`} data-telemetry-label="Select form" onChange={onToggle} />
        </label>
      ) : <ClipboardList className="size-5 text-muted-foreground" aria-hidden="true" />}
      actions={((onToggle && onPreview) || onRemove) ? <>
        {onToggle && onPreview && <Button type="button" size="sm" variant="quiet" aria-label={`Preview ${form.name}`} onClick={onPreview}>Preview</Button>}
        {onRemove && <Button type="button" size="sm" variant="quiet" aria-label={`Remove ${form.name}`} onClick={onRemove}>Remove</Button>}
      </> : undefined}
    />
  );
}
